"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _cmsDesignComponent = require("@tencent/cms-design-component");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
const _excluded = ["radioTxtList"],
  _excluded2 = ["configuration"];
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const formatData = data => {
  const _data$radioTxtList = data.radioTxtList,
    radioTxtList = _data$radioTxtList === void 0 ? [] : _data$radioTxtList,
    rest = (0, _objectWithoutProperties2.default)(data, _excluded);
  const radioTxtListTemp = radioTxtList.map(item => {
    const _item$configuration = item.configuration,
      configuration = _item$configuration === void 0 ? [] : _item$configuration,
      rest1 = (0, _objectWithoutProperties2.default)(item, _excluded2);
    const configurationTemp = configuration.map((item1, index1) => {
      const _item1$header = item1.header,
        header = _item1$header === void 0 ? '' : _item1$header,
        _item1$contentTitle = item1.contentTitle,
        contentTitle = _item1$contentTitle === void 0 ? '' : _item1$contentTitle,
        _item1$contentDesc = item1.contentDesc,
        contentDesc = _item1$contentDesc === void 0 ? '' : _item1$contentDesc,
        _item1$publishTime = item1.publishTime,
        publishTime = _item1$publishTime === void 0 ? '' : _item1$publishTime,
        _item1$href = item1.href,
        href = _item1$href === void 0 ? '' : _item1$href;
      return {
        header,
        contentTitle,
        contentDesc,
        publishTime,
        href,
        extendProps: {
          'report-event': 'click_SelectCard_href',
          'report-ext1': index1,
          'report-ext2': item.header
        }
      };
    });
    return _objectSpread({
      configuration: configurationTemp
    }, rest1);
  });
  return _objectSpread({
    radioTxtList: radioTxtListTemp
  }, rest);
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString;
  const componentData = formatData(data);
  if (componentData) {
    const _componentData$radioT = componentData.radioTxtList,
      radioTxtList = _componentData$radioT === void 0 ? [] : _componentData$radioT,
      _componentData$modTit = componentData.modTitle,
      modTitle = _componentData$modTit === void 0 ? '' : _componentData$modTit;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_selectCard', componentKey, modTitle])), /*#__PURE__*/React.createElement(_cmsDesignComponent.SelectCard, {
      radioTxtList: radioTxtList
    }));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
}